// extracted by mini-css-extract-plugin
export default {"container":"PopoverPaper_container__1fm3r"};